import React, { useEffect, useState } from "react";
import axios from "../../utils/axios";
import "./ActivityLog.css";
import { FaArrowRight, FaRegCopy, FaTimes, FaBars, FaTable, FaGlobe, FaMobileAlt, FaSignOutAlt, FaQuestionCircle, FaUserCircle } from "react-icons/fa";
import { FaHome } from "react-icons/fa";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import airplaneImage from "../../assets/airplane.png";
import "../Home/Home.css";

const truncateWithCopy = (str, maxLen = 30) => {
  if (!str) return "";
  const s = String(str);
  if (s.length <= maxLen) return s;
  return s.slice(0, maxLen) + "...";
};

const CopyButton = ({ value }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    toast("Copied!");
  };
  return (
    <button onClick={handleCopy} style={{ marginLeft: 6, background: 'none', border: 'none', cursor: 'pointer', color: '#1572dd', fontSize: 14 }} title="Copy to clipboard">
      <FaRegCopy />
    </button>
  );
};


const ActivityLog = () => {
  const [columns, setColumns] = useState([]);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedLog, setSelectedLog] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const toggleHelp = () => setShowHelp((prev) => !prev);
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMetaAndLogs = async () => {
      setLoading(true);
      setError("");
      try {
        const [metaRes, logsRes] = await Promise.all([
          axios.get("/api/action_log/meta"),
          axios.get("/api/action_log/")
        ]);
        setColumns(metaRes.data.columns || []);
        setLogs(logsRes.data);
      } catch (err) {
        setError("Failed to fetch activity logs or metadata");
      } finally {
        setLoading(false);
      }
    };
    fetchMetaAndLogs();
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="layout-wrapper">
      {/* Top Header */}
      <header className="top-bar" style={{ position: "relative" }}>
        <div className="sidebar-top-row" style={{ position: "absolute", left: 20, top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center" }}>
          {!collapsed && (
            <img src={logo} onClick={() => navigate("/home")} alt="Logo" className="sidebar-logo" />
          )}
          <button
            className="menu-btn sidebar-menu-btn"
            onClick={() => setCollapsed((prev) => !prev)}
            aria-label="Toggle sidebar"
            style={{ marginLeft: !collapsed ? 0 : 0 }}
          >
            <FaBars size={24} />
          </button>
        </div>
        <h1 className="portal-title" style={{ margin: 0, position: "absolute", left: 0, right: 0, textAlign: "center", pointerEvents: "none" }}>Lounge Atlas Portal</h1>
        <div style={{ position: "absolute", right: 20, top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", gap: 12 }}>
          <button className="class1-btn" onClick={() => navigate("/profile")}
          >
            <FaUserCircle size={24}/>
          </button>
          <button className="class1-btn" onClick={toggleHelp}>
            <FaQuestionCircle size={20} />
          </button>
        </div>
      </header>

      {/* Body */}
  <div className="body-section">
        {/* Sidebar */}
        <aside className={`side-panel ${collapsed ? "collapsed" : ""}`} style={{ margin: "0px 0px 0px 0px" }}>
          {/* Airplane image (below logo/menu row) */}
          {!collapsed && (
            <div className="sidebar-image">
              <img src={airplaneImage} alt="Airplane" />
            </div>
          )}

          <nav className="side-menu">
            <button onClick={() => navigate("/home")}> 
              <FaHome />
              {!collapsed && <span>Home</span>}
            </button>
            <button onClick={() => openInNewTab("https://ieg-america.com/")}> 
              <FaGlobe />
              {!collapsed && <span>IEG Website</span>}
            </button>
            <button onClick={() => openInNewTab("https://app.loungeatlas.com/")}>
              <FaMobileAlt />
              {!collapsed && <span>Lounge Atlas App</span>}
            </button>
            <button onClick={handleLogout}>
              <FaSignOutAlt />
              {!collapsed && <span>Sign Out</span>}
            </button>
          </nav>
        </aside>

        {/* Main Content */}
        <main className="main-panel">
          <div className="main-card" style={{ minHeight: 700, minWidth: 1200, height: 700, width: 1200, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'stretch' }}>
            <div className="main-content" style={{ flex: 1 }}>
              <h2 style={{ marginBottom: 24, fontSize: 36 }}>Activity Log</h2>
              {loading && <div>Loading...</div>}
              {error && <div style={{ color: "#b71c1c" }}>{error}</div>}
              {!loading && !error && logs.length === 0 && <div>No logs found.</div>}
              {!loading && logs.length > 0 && columns.length > 0 && (
                <div style={{ maxWidth: 1050, borderRadius: 8, border: '1px solid #e0e0e0', background: '#fff', margin: '0 auto', position: 'relative' }}>
                  <table className="activity-log-table" style={{ minWidth: 1050, borderCollapse: "collapse", fontSize: 22 }}>
                    <thead>
                      <tr>
                        {columns.filter(col => col !== "OldValues" && col !== "NewValues").map((col) => (
                          <th key={col}>{col}</th>
                        ))}
                      </tr>
                    </thead>
                  </table>
                  <div style={{ maxHeight: 480, overflowY: 'auto', overflowX: 'auto' }}>
                    <table className="activity-log-table" style={{ minWidth: 1050, borderCollapse: "collapse", fontSize: 22 }}>
                      <tbody>
                        {logs.map((log) => (
                          <tr key={log.LogID} style={{ cursor: "pointer", background: selectedLog?.LogID === log.LogID ? "#e3f7e7" : undefined }} onClick={() => setSelectedLog(log)}>
                            {columns.filter(col => col !== "OldValues" && col !== "NewValues").map((col) => (
                              <td key={col} title={log[col]}>
                                {col === "Timestamp"
                                  ? new Date(log[col]).toLocaleString()
                                  : log[col]}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {selectedLog && columns.length > 0 && (
                <div style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  background: 'rgba(14,38,90,0.18)',
                  zIndex: 1000,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                  onClick={() => setSelectedLog(null)}
                >
                  <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 6px 24px rgba(21,114,221,0.18)', padding: 36, minWidth: 420, maxWidth: 600, maxHeight: '80vh', overflowY: 'auto', position: 'relative', border: '2px solid #1572dd', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }} onClick={e => e.stopPropagation()}>
                    <h3 style={{ color: '#1565c0', fontWeight: 700, marginBottom: 18 }}>Log Details (LogID: {selectedLog.LogID})</h3>
                    <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap', justifyContent: 'center' }}>
                      {(() => {
                        // Parse both old and new values for comparison
                        let oldParsed = {};
                        let newParsed = {};
                        try { oldParsed = selectedLog.OldValues ? JSON.parse(selectedLog.OldValues) : {}; } catch { oldParsed = { raw: selectedLog.OldValues }; }
                        try { newParsed = selectedLog.NewValues ? JSON.parse(selectedLog.NewValues) : {}; } catch { newParsed = { raw: selectedLog.NewValues }; }

                        // Get all unique keys
                        const allKeys = Array.from(new Set([
                          ...Object.keys(oldParsed),
                          ...Object.keys(newParsed)
                        ]));

                        return [
                          ['Old Values', oldParsed, newParsed],
                          ['New Values', newParsed, oldParsed]
                        ].map(([label, parsed, otherParsed], idx) => (
                          <div key={label} style={{ background: '#f0f4ff', borderRadius: 10, padding: 18, minWidth: 360, flex: 2, boxShadow: '0 2px 8px rgba(21,114,221,0.08)' }}>
                            <div style={{ color: '#1565c0', fontWeight: 600, fontSize: 16, marginBottom: 10 }}>{label}</div>
                            {allKeys.length === 0 ? (
                              <div style={{ color: '#888', fontStyle: 'italic' }}>N/A</div>
                            ) : (
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                {allKeys.map((k) => {
                                  const kStr = String(k);
                                  const vRaw = parsed[k];
                                  if (vRaw === undefined || vRaw === null || vRaw === "") return null;
                                  const vStr = String(vRaw);
                                  const otherVStr = String(otherParsed[k] ?? '');
                                  const showCopyK = kStr.length > 30;
                                  const showCopyV = vStr.length > 30;
                                  // Highlight if value is different between old and new
                                  const isChanged = (parsed === oldParsed && vStr !== otherVStr) || (parsed === newParsed && vStr !== otherVStr);
                                  return (
                                    <div key={k} style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 8,
                                      background: isChanged ? '#d6f5e6' : '#fff',
                                      borderRadius: 6,
                                      padding: '6px 10px',
                                      boxShadow: '0 1px 4px rgba(21,114,221,0.04)'
                                    }}>
                                      <span style={{ color: '#0e265a', fontWeight: 500 }}>
                                        {truncateWithCopy(kStr)}
                                        {showCopyK && <CopyButton value={kStr} />}
                                      </span>
                                      <FaArrowRight style={{ color: '#1572dd', fontSize: 14 }} />
                                      <span style={{ color: '#1565c0', fontWeight: 500 }}>
                                        {truncateWithCopy(vStr)}
                                        {showCopyV && <CopyButton value={vStr} />}
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        ));
                      })()}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32 }}>
                      <button style={{ background: '#1565c0', color: '#fff', borderRadius: 7, padding: '8px 22px', border: 'none', fontWeight: 700, fontSize: 16, cursor: 'pointer', boxShadow: '0 2px 8px rgba(21,114,221,0.08)' }} onClick={() => setSelectedLog(null)}>Close</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </main>
      </div>

      {showHelp && (
        <>
          <div className="overlay-backdrop" onClick={toggleHelp}></div>
          <div className="help-overlay">
            <h2>Need Help?</h2>
            <p><strong>Phone:</strong> +1 (514) 871-4910</p>
            <p><strong>Email:</strong> support@loungeatlas.com</p>
            <button className="close-icon" onClick={toggleHelp}>
              <FaTimes size={20} />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ActivityLog;
